import { Component, Inject, Input } from '@angular/core';
import { ExcoBoardDocumentRecord } from '../../../shared/models/app-models/ExcoBoardDocument.model';
import { ExcoBoardColumns } from '../../shared/constants';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { Subject, lastValueFrom, takeUntil } from 'rxjs';
import { SelectionModel } from '@angular/cdk/collections';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { SearchInput } from 'src/app/shared/components/selectable-table/selectable-table.component';
import { AlertType } from 'src/app/shared/components/alert/alert.component';

@Component({
  selector: 'app-add-exco-document-dialog',
  templateUrl: './add-exco-document-dialog.component.html',
  styleUrls: ['./add-exco-document-dialog.component.scss']
})
export class AddExcoDocumentDialogComponent {
  excoBoardDocumentArray: ExcoBoardDocumentRecord[] = []
  excoBoardColumns: any = ExcoBoardColumns
  destroy$: Subject<boolean> = new Subject<boolean>();
  totalRecords: number = 0
  selectedData: SelectionModel<ExcoBoardDocumentRecord> = new SelectionModel<ExcoBoardDocumentRecord>(true, []);
  AORDocumentArray: ExcoBoardDocumentRecord[] = [];
  duplicateFound: boolean = false

  constructor(private backendService: BackendApiService, public matDialogRef: MatDialogRef<ExcoBoardDocumentRecord>,@Inject(MAT_DIALOG_DATA) public data: any) {
    this.AORDocumentArray = data;
  }
  async ngOnInit() {
    await this.loadData(5, 1)
  }
  async handlePageEvent(event: PageEvent) {
    await this.loadData(event.pageSize, event.pageIndex + 1)
  }
  async loadData(pageLimit: number, pageIndex: number, searchTerm?: string) {
    const myData = await lastValueFrom(this.backendService.getPreApproved(pageLimit, pageIndex, searchTerm))
    const results = myData.approved.map((x: any) => {
      const { Attaachments, Author, Editor, ...remainingData } = x
      const result = { IsDeleted: false, ...remainingData }
      return result
    })
    this.totalRecords = myData.totalCount
    this.excoBoardDocumentArray = results
  }
  onSubmit() {
    const selectedRecords: ExcoBoardDocumentRecord[] = []
    for (const data of this.excoBoardDocumentArray) {
      if (this.selectedData.isSelected(data)){
        let duplicateRecord = this.checkDuplicate(data);
        if(duplicateRecord) return
        selectedRecords.push(data as ExcoBoardDocumentRecord)
      }
    }
    if(!this.duplicateFound) this.matDialogRef.close(selectedRecords)
  }
  async handleSearchEvent(event: SearchInput) {
    await this.loadData(event.pageSize, event.pageIndex + 1, event.searchValue)
  }

  checkDuplicate(selectedRecords : any){
    this.duplicateFound = false;
    let filteredRecords = this.AORDocumentArray.filter((record: any) => !record.IsDeleted);
    for (const record of filteredRecords) {
      if(record.id == selectedRecords.id){
        this.duplicateFound = true;
        return this.duplicateFound;
      }
    }
    return this.duplicateFound;
  }
  public get alertType(): typeof AlertType {
    return AlertType;
  }
}
